import {
  showRulesNavSelector,
  showSuppliersNavSelector,
  useBrandedTrackingSelector,
  useContactsSelector,
} from '../../data/company.js'
import {showAPIKeysNavSelector} from '../../data/me.js'
import {showReturnOrdersNavSelector} from '../../redux/selectors/data/returnOrders.js'

export const SETTINGS = 'settings'

export const ACCOUNTING = 'accounting'
export const API_KEYS = 'api_key'
export const BARCODE_SCANNERS = 'barcode_scanners'
export const BILLING = 'billing'
export const CONTACTS = 'contacts'
export const GENERAL = 'general'
export const PACKING_LISTS = 'profiles'
export const PROFILES_GENERAL = 'general'
export const PROFILES_PACKING_LIST = 'packing_list'
export const PROFILES_RETURN_ORDER = 'return_order'
export const PROFILES_SHIP_FROM_ALIAS = 'ship_from_alias'
export const PROFILES_BRANDED_TRACKING = 'branded_tracking_page'
export const PAYMENTS = 'payments'
export const PRESETS = 'presets'
export const PRINTING = 'printing'
export const PURCHASE_ORDERS = 'purchase_orders'
export const RETURN_ORDER_CODES = 'return_order_codes'
export const RULES = 'rules'
export const SALES_CHANNELS = 'saleschannels'
export const SCALES = 'scales'
export const SHIPPERS = 'shipper'
export const SHIPPING_INSURANCE = 'shipping_insurance'
export const SUPPLIERS = 'supplier'
export const THREE_P_L = '3PL'
export const USERS = 'user'
export const WAREHOUSES = 'warehouse'

export const SECTION_ACCOUNT_SETTINGS = 'Account Settings'
export const SECTION_FULFILLMENT = 'Fulfillment'
export const SECTION_INTEGRATIONS = 'Integrations'
export const SECTION_PROFILES = 'Profiles'
export const SECTION_PURCHASE_ORDERS = 'Purchase Orders'
export const SECTION_RETURNS = 'Returns'
export const SECTION_DEVICES = 'Devices'
export const SECTION_AUTOMATION = 'Automation'

export const PROFILES__GENERAL = `${PACKING_LISTS}__${PROFILES_GENERAL}`
export const PROFILES__PACKING_LIST = `${PACKING_LISTS}__${PROFILES_PACKING_LIST}`
export const PROFILES__RETURN_ORDER = `${PACKING_LISTS}__${PROFILES_RETURN_ORDER}`
export const PROFILES__SHIP_FROM_ALIAS = `${PACKING_LISTS}__${PROFILES_SHIP_FROM_ALIAS}`
export const PROFILES__BRANDED_TRACKING = `${PACKING_LISTS}__${PROFILES_BRANDED_TRACKING}`

export const SETTINGS_PANEL_OPTIONS = [
  {
    value: GENERAL,
    display: 'General',
    dropdownDisplay: 'Account Settings',
    section: SECTION_ACCOUNT_SETTINGS,
    canPin: false,
  },
  {value: USERS, display: 'Users', section: SECTION_ACCOUNT_SETTINGS},
  {
    value: CONTACTS,
    display: 'Contacts',
    includeSelector: useContactsSelector,
    section: SECTION_ACCOUNT_SETTINGS,
  },
  {value: BILLING, display: 'Billing', section: SECTION_ACCOUNT_SETTINGS},
  {
    value: API_KEYS,
    display: 'API Keys',
    includeSelector: showAPIKeysNavSelector,
    section: SECTION_ACCOUNT_SETTINGS,
  },
  {value: WAREHOUSES, display: 'Warehouses', section: SECTION_FULFILLMENT},
  {
    value: SUPPLIERS,
    display: 'Suppliers',
    includeSelector: showSuppliersNavSelector,
    section: SECTION_FULFILLMENT,
  },
  {
    value: THREE_P_L,
    display: '3PLs',
    section: SECTION_FULFILLMENT,
    canPin: false,
  },
  {
    value: SALES_CHANNELS,
    display: 'Sales Channels',
    additionalNouns: 'cart',
    section: SECTION_INTEGRATIONS,
  },
  {
    value: SHIPPERS,
    display: 'Shippers/Carriers',
    section: SECTION_INTEGRATIONS,
  },
  {value: ACCOUNTING, display: 'Accounting', section: SECTION_INTEGRATIONS},
  {value: PAYMENTS, display: 'Payments', section: SECTION_INTEGRATIONS},
  {
    value: SHIPPING_INSURANCE,
    display: 'Shipping Insurance',
    section: SECTION_INTEGRATIONS,
    canPin: false,
  },
  {
    value: PROFILES__GENERAL,
    display: 'General',
    dropdownDisplay: 'Profiles',
    path: [SETTINGS, PACKING_LISTS, PROFILES_GENERAL],
    section: SECTION_PROFILES,
    topLevel: true,
  },
  {
    value: PROFILES__PACKING_LIST,
    display: 'Packing Lists',
    path: [SETTINGS, PACKING_LISTS, PROFILES_PACKING_LIST],
    section: SECTION_PROFILES,
  },
  {
    value: PROFILES__RETURN_ORDER,
    display: 'Return Emails',
    path: [SETTINGS, PACKING_LISTS, PROFILES_RETURN_ORDER],
    includeSelector: showReturnOrdersNavSelector,
    section: SECTION_PROFILES,
  },
  {
    value: PROFILES__SHIP_FROM_ALIAS,
    display: 'Ship From Alias',
    path: [SETTINGS, PACKING_LISTS, PROFILES_SHIP_FROM_ALIAS],
    section: SECTION_PROFILES,
  },
  {
    value: PROFILES__BRANDED_TRACKING,
    display: 'Branded Tracking Page',
    path: [SETTINGS, PACKING_LISTS, PROFILES_BRANDED_TRACKING],
    includeSelector: useBrandedTrackingSelector,
    section: SECTION_PROFILES,
  },
  {
    value: PURCHASE_ORDERS,
    display: 'PO ID Format',
    section: SECTION_PURCHASE_ORDERS,
  },
  {
    value: RETURN_ORDER_CODES,
    display: 'Return Codes',
    includeSelector: showReturnOrdersNavSelector,
    section: SECTION_RETURNS,
  },
  {value: PRINTING, display: 'Printers', section: SECTION_DEVICES},
  {value: SCALES, display: 'Scales', section: SECTION_DEVICES},
  {
    value: BARCODE_SCANNERS,
    display: 'Barcode Scanners',
    section: SECTION_DEVICES,
  },
  {value: PRESETS, display: 'Presets', section: SECTION_AUTOMATION},
  {
    value: RULES,
    display: 'Rules',
    includeSelector: showRulesNavSelector,
    section: SECTION_AUTOMATION,
  },
]

export const NEW_ID = 'new'
export const EDIT = 'edit'

export const ACCOUNTING_SETTINGS_LINK = `#/${SETTINGS}/${ACCOUNTING}`
export const USER_SETTINGS_LINK = `#/${SETTINGS}/${USERS}`
export const SALES_CHANNEL_SETTINGS_LINK = `#/${SETTINGS}/${SALES_CHANNELS}`
export const WAREHOUSE_SETTINGS_LINK = `#/${SETTINGS}/${WAREHOUSES}`
export const SUPPLIER_SETTINGS_LINK = `#/${SETTINGS}/${SUPPLIERS}`
export const PACKING_LIST_SETTINGS_LINK = `#/${SETTINGS}/${PACKING_LISTS}`
